module.exports = __webpack_public_path__ + "static/media/Tank_Level.cef89958.svg";